/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface StringAnswerDTO {
  answer?: string;
}

export interface SurveyAnswerRequestDTO {
  /** @format int32 */
  questionId: number;
  /** @format int32 */
  answerId: number;
}

export interface UserProgressDTO {
  /** @format int32 */
  stepId?: number;
}

export interface GetUserProgressRequestDTO {
  /** @format int32 */
  storyId: number;
}

export interface ChangeUserProgressRequestDTO {
  /** @format int32 */
  stepId: number;
}

export interface UpdatePasswordRequestDTO {
  email: string;
  code: string;
  /**
   * @minLength 6
   * @maxLength 2147483647
   */
  newPassword: string;
  /**
   * @minLength 6
   * @maxLength 2147483647
   */
  confirmPassword: string;
}

export interface ResetCodeRequestDTO {
  email: string;
}

export interface MessageRequestDTO {
  /**
   * @minLength 3
   * @maxLength 2147483647
   */
  subject: string;
  /**
   * @minLength 10
   * @maxLength 2147483647
   */
  message: string;
}

export interface SignUpRequestDTO {
  /**
   * @minLength 3
   * @maxLength 50
   */
  username: string;
  /**
   * @minLength 3
   * @maxLength 50
   */
  surname: string;
  email: string;
  /**
   * @minLength 6
   * @maxLength 2147483647
   */
  password: string;
}

export interface SignInDTO {
  token?: string;
  /** @format int32 */
  planId?: number;
}

export interface SignInRequestDTO {
  email: string;
  password: string;
}

export interface UserDTO {
  email?: string;
  name?: string;
  /** @format int32 */
  planId?: number;
}

export interface SurveyAnswerDTO {
  /** @format int32 */
  answerId?: number;
  answerText?: string;
  answerAudioUrl?: string;
}

export interface SurveyDTO {
  /** @format int32 */
  questionId?: number;
  questionText?: string;
  audioUrl?: string;
  answerList?: SurveyAnswerDTO[];
}

export interface StoryDTO {
  /** @format int32 */
  id?: number;
  title?: string;
  description?: string;
  /** @format int32 */
  planId?: number;
  isBlock?: boolean;
  /** @format date-time */
  createdAt?: string;
  mainImageUrl?: string;
  /** @format int32 */
  firstStepId?: number;
  firstStepImageUrl?: string;
}

export interface ChoiceDto {
  /** @format int32 */
  nextStepId?: number;
  choiceText?: string;
  nextStepImageUrl?: string;
  choiceAudioUrl?: string;
}

export interface StepDTO {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  storyId?: number;
  storyName?: string;
  stepText?: string;
  illustrationUrl?: string;
  audioUrl?: string;
  choicesList?: ChoiceDto[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;
import { links } from "../config/links";
import {
  localStorageService,
  LocalStorageVariableName,
} from "../services/localStorage-service";
export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://yumi-story.com";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, { ...apiConfig, headers: {} });
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key]
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    // const myHeaders = {...}

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
          ...(localStorageService.getValue<string>(
            LocalStorageVariableName.token
          ) !== undefined
            ? {
                Authorization:
                  "Bearer " +
                  localStorageService.getValue<string>(
                    LocalStorageVariableName.token
                  ),
              }
            : {}),
          // Authorization: "Bearer " + localStorageService.getValue<string>(LocalStorageVariableName.token),
          "X-FP-API-KEY": "iphone",
          "Content-Type": "application/json",
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      }
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;

      if (r.data === null) {
        if ((r.error as SyntaxError).message.includes("offline")) {
          window.location.replace(links.offline);
        }
      }
      r.data = null as unknown as T;
      r.error = null as unknown as E;
   
      if (r.status == 401 && r.url.includes("sign-in")) {
        return r;
      }
      if (r.status == 401 && !r.url.includes("sign-in")) {
        window.location.replace(links.login);
      }

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl https://yumi-story.com
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Позволяет сохранить ответ пользователя
     *
     * @tags Survey
     * @name SendSurveyAnswer
     * @summary Сохранить ответ пользователя
     * @request POST:/api/survey/send-answer
     */
    sendSurveyAnswer: (
      data: SurveyAnswerRequestDTO,
      params: RequestParams = {}
    ) =>
      this.request<StringAnswerDTO, void>({
        path: `/api/survey/send-answer`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает текущий прогресс пользователя в указанной сказке.
     *
     * @tags User Progress
     * @name GetUserProgress
     * @summary Получить прогресс пользователя
     * @request POST:/api/progress/get
     */
    getUserProgress: (
      data: GetUserProgressRequestDTO,
      params: RequestParams = {}
    ) =>
      this.request<UserProgressDTO, void>({
        path: `/api/progress/get`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновляет прогресс пользователя на указанный шаг в заданной сказке.
     *
     * @tags User Progress
     * @name ChangeUserProgress
     * @summary Изменить прогресс пользователя
     * @request POST:/api/progress/change
     */
    changeUserProgress: (
      data: ChangeUserProgressRequestDTO,
      params: RequestParams = {}
    ) =>
      this.request<StringAnswerDTO, void>({
        path: `/api/progress/change`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Позволяет пользователю обновить пароль с помощью кода.
     *
     * @tags Password
     * @name UpdatePassword
     * @summary Изменение пароля
     * @request POST:/api/password/update
     */
    updatePassword: (
      data: UpdatePasswordRequestDTO,
      params: RequestParams = {}
    ) =>
      this.request<StringAnswerDTO, void>({
        path: `/api/password/update`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Отправляет код для сброса пароля на указанный email.
     *
     * @tags Password
     * @name SendResetCode
     * @summary Отправка кода восстановления
     * @request POST:/api/password/code
     */
    sendResetCode: (data: ResetCodeRequestDTO, params: RequestParams = {}) =>
      this.request<StringAnswerDTO, void>({
        path: `/api/password/code`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Позволяет пользователю связаться с нами.
     *
     * @tags Message
     * @name SendMessage
     * @summary Отправить сообщение пользователя
     * @request POST:/api/message/send
     */
    sendMessage: (data: MessageRequestDTO, params: RequestParams = {}) =>
      this.request<StringAnswerDTO, void>({
        path: `/api/message/send`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Позволяет создать нового пользователя.
     *
     * @tags Authorization
     * @name SignUp
     * @summary Регистрация
     * @request POST:/api/auth/sign-up
     */
    signUp: (data: SignUpRequestDTO, params: RequestParams = {}) =>
      this.request<StringAnswerDTO, void>({
        path: `/api/auth/sign-up`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Позволяет пользователю войти в систему. Возвращает JWT-токен и данные пользователя.
     *
     * @tags Authorization
     * @name SignIn
     * @summary Логин
     * @request POST:/api/auth/sign-in
     */
    signIn: (data: SignInRequestDTO, params: RequestParams = {}) =>
      this.request<SignInDTO, void>({
        path: `/api/auth/sign-in`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает информацию о пользователе.
     *
     * @tags User
     * @name GetUser
     * @summary Получить информацию о пользователе
     * @request GET:/api/user
     */
    getUser: (params: RequestParams = {}) =>
      this.request<UserDTO, void>({
        path: `/api/user`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает один случайный вопрос
     *
     * @tags Survey
     * @name GetSurveyQuestion
     * @summary Получить случайный вопрос
     * @request GET:/api/survey/get-question
     */
    getSurveyQuestion: (params: RequestParams = {}) =>
      this.request<SurveyDTO, void>({
        path: `/api/survey/get-question`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает список всех доступных сказок.
     *
     * @tags Stories
     * @name GetAllStories
     * @summary Получить все сказки
     * @request GET:/api/stories
     */
    getAllStories: (params: RequestParams = {}) =>
      this.request<StoryDTO, void>({
        path: `/api/stories`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает данные сказки по указанному идентификатору.
     *
     * @tags Stories
     * @name GetStory
     * @summary Получить сказку по id
     * @request GET:/api/stories/{id}
     */
    getStory: (id: number, params: RequestParams = {}) =>
      this.request<StoryDTO, void>({
        path: `/api/stories/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает данные шага сказки по указанному идентификатору.
     *
     * @tags Stories
     * @name GetStep
     * @summary Получить шаг по id
     * @request GET:/api/stories/step/{stepId}
     */
    getStep: (stepId: number, params: RequestParams = {}) =>
      this.request<StepDTO, void>({
        path: `/api/stories/step/${stepId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags download-controller
     * @name DownloadApp
     * @request GET:/api/download
     */
    downloadApp: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/api/download`,
        method: "GET",
        ...params,
      }),
  };
}
